// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"78d2bdc8","787":"d7e7aaf3"}[chunkId] + ".chunk.js";
};